<div class="trigger-wrapper">
  <span (click)="toggle($event)">
    {{
      (collapsed ? 'app.activities.show_difference' : 'app.activities.hide_difference') | translate
    }}
    <rt-icon [name]="collapsed ? 'arrow-drop-down' : 'arrow-drop-up'"></rt-icon>
  </span>
</div>
@if (!collapsed) {
  <div class="difference">
    <div class="content">{{ previousContent }}</div>
    <div class="icon">
      <rt-icon name="arrow-forward"></rt-icon>
    </div>
    <div class="content">{{ currentContent }}</div>
  </div>
}
